import { render, staticRenderFns } from "./all-day-detail.vue?vue&type=template&id=2e020c02&scoped=true&"
import script from "./all-day-detail.vue?vue&type=script&lang=js&"
export * from "./all-day-detail.vue?vue&type=script&lang=js&"
import style0 from "./all-day-detail.vue?vue&type=style&index=0&id=2e020c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e020c02",
  null
  
)

export default component.exports